var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTarifasIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 36,
    viewBox: "0 0 36 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Frame"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M30.8052 23.1964C33.6742 16.1261 30.2684 8.0688 23.1982 5.1998C16.128 2.33081 8.07061 5.73659 5.20161 12.8068C2.33262 19.8771 5.7384 27.9344 12.8086 30.8034C19.8789 33.6724 27.9362 30.2666 30.8052 23.1964Z",
    stroke: "#0985C7",
    strokeMiterlimit: 10
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M19.1053 24.8221V26.9588H17.2016V24.8789C15.3149 24.7653 13.5022 24.1743 12.4565 23.356L13.5022 21.0317C14.4569 21.7364 15.8264 22.2535 17.2016 22.3842V19.2019C15.0876 18.6848 12.7236 17.9801 12.7236 15.2581C12.7236 13.2407 14.1898 11.5018 17.2016 11.1608V9.04688H19.1053V11.1267C20.5317 11.2404 21.9239 11.6211 22.9752 12.2917L22.0206 14.6387C21.0488 14.0874 20.06 13.7635 19.1053 13.6499V16.889C21.2193 17.3834 23.5435 18.0881 23.5435 20.776C23.5492 22.7479 22.1001 24.4641 19.1053 24.8221ZM17.2016 16.4003V13.6953C16.1901 13.9226 15.7923 14.4796 15.7923 15.1046C15.7923 15.7695 16.3606 16.1332 17.2016 16.4003ZM20.4805 20.9919C20.4805 20.3271 19.9293 19.9634 19.111 19.6792V22.3103C20.06 22.1001 20.4805 21.6057 20.4805 20.9919Z",
    fill: "#0985C7"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTarifasIcon);
export default __webpack_public_path__ + "static/media/tarifas-icon.19635c8204ff25e144cb39a9bdacb3e1.svg";
export { ForwardRef as ReactComponent };